<template>
    <div class="basic">
        <div class="mainMenu">
            <div class="menuTitle">
                <div class="textTitle">
                    {{menuInfo[0].title2}}
                </div>
                <!--title-->
            </div>

            <div class="menu">
                <div class="subMenuAll">

                    <!-- 미납 미포함 메뉴 -->
                    <!-- <router-link class="parkInfo" :to="{ name: '요금안내' }">
                        <ul id="subMenuAll" class="subMenu2" @click="defaultMenu">
                            <li class="subMenuText">
                                {{menuInfo[2].menu1}}
                                <span class="arrow">&rsaquo;</span>
                            </li>
                        </ul>
                    </router-link> -->


                    <ul id="dropDownMenu" class="subMenu2">
                        <li class="dropDownText" :class="{ active : this.$store.isCoin }">
                            <router-link class="dropDownInfo" :to="{ name: '요금안내' }">
                                <div class="lineDrop" @click="changeCoin">
                                    <div class="dropText">
                                        {{menuInfo[2].menu1}}
                                        <span class="arrow">&rsaquo;</span> 
                                    </div>
                                    <hr class="line"/>
                                </div>
                            </router-link>
                            
                            <a class="dropdown-toggle" data-toggle="dropdown" role="button">
                                <ul class="dropdown-menu" role="menu">

                                    <router-link class="miniMenuLink" :to="{ name: '요금안내' }">
                                        <li class="depthMenu" @click="changeCoin">
                                            {{menuInfo[3].subMenu1}}
                                        </li>
                                    </router-link>

                                    <router-link class="miniMenuLink" :to="{ name: '할인안내' }">
                                        <li class="depthMenu" @click="changeCoin">
                                            {{menuInfo[3].subMenu3}}
                                        </li>
                                    </router-link>

                                    <!-- <router-link class="miniMenuLink" :to="{ name: '학교주차장 현황' }">
                                        <li class="depthMenu" @click="changeSubmit">
                                            {{menuInfo[4].subMenu3}}
                                        </li>
                                    </router-link> -->
                                </ul>
                            </a>

                        </li>
                    </ul>


                    <!-- 미납 포함 메뉴 시작 -->
                    <!-- <ul id="dropDownMenu" class="subMenu2">
                        <li class="dropDownText" :class="{ active : this.$store.isActive }">
                            <router-link class="dropDownInfo" :to="{ name: '요금안내' }">
                                <div class="lineDrop" @click="changeMenu">
                                    
                                    <div class="dropText">
                                        {{menuInfo[2].menu1}}
                                        <span class="arrow">&rsaquo;</span>
                                    </div>
                                    <hr class="line"/>
                                </div>
                            </router-link>
                            
                            
                            <a class="dropdown-toggle" data-toggle="dropdown" role="button">
                                <ul class="dropdown-menu" role="menu" >

                                    <router-link class="miniMenuLink" :to="{ name: '요금안내' }">
                                        <li class="depthMenu" @click="changeMenu">
                                            {{menuInfo[3].subMenu1}}
                                        </li>
                                    </router-link>
                                </ul>

                                <ul class="dropdown-menu" role="menu">
                                    <router-link  router-link class="miniMenuLink" :to="{ name: '미납주차 요금안내' }">
                                        <li class="depthMenu" @click="changeMenu">
                                            {{menuInfo[3].subMenu2}}
                                        </li>
                                    </router-link>
                                </ul>
                            </a>
                        </li>
                    </ul> -->
                    <!-- 미납 포함 메뉴 끝 -->

                    <!--1 Depth-->
                    <ul id="dropDownMenu" class="subMenu2">
                        <li class="dropDownText" :class="{ active : this.$store.isSubmit }">
                            <router-link class="dropDownInfo" :to="{ name: '노상주차장 현황' }">
                                <div class="lineDrop" @click="changeSubmit">
                                    <div class="dropText">
                                        {{menuInfo[2].menu2}}
                                        <span class="arrow">&rsaquo;</span> 
                                    </div>
                                    <hr class="line"/>
                                </div>
                            </router-link>
                            
                            <a class="dropdown-toggle" data-toggle="dropdown" role="button">
                                <ul class="dropdown-menu" role="menu">

                                    <router-link class="miniMenuLink" :to="{ name: '노상주차장 현황' }">
                                        <li class="depthMenu" @click="changeSubmit">
                                            {{menuInfo[4].subMenu1}}
                                        </li>
                                    </router-link>

                                    <router-link class="miniMenuLink" :to="{ name: '노외주차장 현황' }">
                                        <li class="depthMenu" @click="changeSubmit">
                                            {{menuInfo[4].subMenu2}}
                                        </li>
                                    </router-link>

                                    <!-- <router-link class="miniMenuLink" :to="{ name: '학교주차장 현황' }">
                                        <li class="depthMenu" @click="changeSubmit">
                                            {{menuInfo[4].subMenu3}}
                                        </li>
                                    </router-link> -->
                                </ul>
                            </a>

                        </li>
                    </ul>

                    <router-link class="parkInfo" :to="{ name: '안내사항' }">
                        <ul id="subMenuAll" class="subMenu2" @click="defaultMenu">
                            <li class="subMenuText">
                                {{menuInfo[2].menu5}}
                                <span class="arrow">&rsaquo;</span>
                            </li>
                        </ul>
                    </router-link>

                    <router-link class="parkInfo" :to="{ name: '확인' }">
                        <ul id="subMenuAll" class="subMenu2" @click="defaultMenu">
                            <li class="subMenuText">
                                {{menuInfo[2].menu3}}
                                <span class="arrow">&rsaquo;</span>
                            </li>
                        </ul>
                    </router-link>

                    <!-- 시간권 메뉴 -->
                    <!-- <router-link class="parkInfo" :to="{ name: '정보' }">
                        <ul id="subMenuAll" class="subMenu2" @click="defaultMenu">
                            <li class="subMenuText">
                                {{menuInfo[2].menu4}}
                                <span class="arrow">&rsaquo;</span>
                            </li>
                        </ul>
                    </router-link> -->

                </div>
            </div>
             <!--1 Depth-->

        </div>
        <router-view class="subView"/>
    </div>
</template>

<script>
import Menu from '@/assets/index/subMenu'

export default {
    data() {
        return {
            menuInfo : Menu
        }
    },
    methods: {
        changeMenu() {
            this.$store.isActive = true
            this.$store.isSubmit = false
            this.$store.isCoin = false
        },
        changeSubmit() {
            this.$store.isActive = false
            this.$store.isSubmit = true
            this.$store.isCoin = false
        },
        changeCoin() {
            this.$store.isActive = false
            this.$store.isSubmit = false
            this.$store.isCoin = true
        },
        defaultMenu() {
            this.$store.isActive = false
            this.$store.isSubmit = false
            this.$store.isCoin = false
        },
    }
}
</script>

<style scoped>
    @import '@/assets/css/reset.css';

    .basic {
        /* display: flex; */
        margin: 0;
        padding: 0;
        height: auto;
    }

    .mainMenu {
        overflow:hidden;
		height:auto;
        width: 25.2% !important;
        float: left;
    }

    .menuTitle {
        padding-top: 1%;
        width: 100%;
        height: 199px;
        background: #3287C3 0% 0% no-repeat padding-box;
        text-align: center;
    }
    
    .mainMenu >>> .menu {
        height: 80%;
        min-height: 1635px;
        /* min-hight: 1000px */
        border: 6px solid #EFEFEF;
        border-top-color: transparent;
        display: block;

        list-style: none !important;
    }

    .textTitle {
        padding-top: 23%;
        /* padding-left: 32%; */
        width: 108px;
        height: 44px;
        text-align: center;
        font: normal normal 30px/44px Noto Sans KR-BOLD;
        letter-spacing: -0.75px;
        color: #FFFFFF;
        opacity: 1;
        display: inline-block;
    }

    #subMenuAll {
        width: 90%;
        height: 46px;
        margin-left: 5%;
        margin-top: 3%;
        /* background: #FFFFFF 0% 0% no-repeat padding-box; */
        border: 1px solid #DBDBDB;
        text-align: left;
        font: normal normal normal 20px/29px Noto Sans KR;
        letter-spacing: -1px;
        color: #707070;

        list-style: none !important;
    }


    #dropDownMenu {
        list-style: none !important;
    }

    #dropDownMenu >>> li{
        list-style: none !important;
    }

    .subMenuText {
        margin-left: 5%;
        margin-top: 3%;
        
    }
    
    .arrow {
        width: 30px;
        height: 30px;
        font-size: 30px;
        font-weight: 600;
        color: #707070;
        text-align: center;
        float: right;
        margin-right: 5%;
        margin-top: -1%;
    }
    
    .dropDownText.active >>> .arrow {
        width: 30px;
        height: 30px;
        font-size: 30px;
        font-weight: 600;
        color: #707070;
        text-align: center;
        float: right;
        margin-right: 5%;
        margin-top: -1%;
        color:#FFFFFF;
        -webkit-transform:rotate(90deg);
        -webkit-transform-origin: center;
        -moz-transform:rotate(90deg); 
        -moz-transform-origin: center;
        -ms-transform:rotate(90deg); 
        -ms-transform-origin: center;
        -o-transform:rotate(90deg);
        -o-transform-origin: center;
    }

    .dropDownText.active >>> .dropText {
        padding-left: 5%;
        padding-top: 3%;
        margin: 0;
        color: #FFFFFF;
        background: #21529F 0% 0% no-repeat padding-box;
    }

    .subView {
        top: 0;
        height: auto !important;
        width: auto;
        margin: 0;
        /* float: right !important; */
    }

    .parkInfo {
        text-decoration:none; 
    }

    .router-link-active >>> #subMenuAll{
        color: #FFFFFF;
        background: #21529F 0% 0% no-repeat padding-box;
    }

    .router-link-active >>> #subMenuAll{
        color: #FFFFFF;
        background: #21529F 0% 0% no-repeat padding-box;
    }

    .router-link-active >>> .dropText{
        padding-left: 5%;
        padding-top: 3%;
        margin: 0;
        /* margin-left: 5%; */
        color: #FFFFFF;
        background: #21529F 0% 0% no-repeat padding-box;
    }

    .router-link-active >>> .arrow {
        width: 30px;
        height: 30px;
        font-size: 30px;
        font-weight: 600;
        color: #707070;
        text-align: center;
        float: right;
        margin-right: 5%;
        margin-top: -1%;
        color:#FFFFFF;
        -webkit-transform:rotate(90deg);
        -webkit-transform-origin: center;
        -moz-transform:rotate(90deg); 
        -moz-transform-origin: center;
        -ms-transform:rotate(90deg); 
        -ms-transform-origin: center;
        -o-transform:rotate(90deg);
        -o-transform-origin: center;
    }

    #subMenu2 >>> a {
        text-decoration:none; 
        color:#707070;
    }
    

    #subMenu2 >>> a {
        background: #21529F 0% 0% no-repeat padding-box;
    }

    .dropDownInfo {
        text-decoration:none; 
    }

    #dropDownMenu {
        width: 90%;
        margin-left: 5%;
        margin-top: 3%;
        /* background: #FFFFFF 0% 0% no-repeat padding-box; */
        border: 1px solid #DBDBDB;
        text-align: left;
        font: normal normal normal 20px/29px Noto Sans KR;
        letter-spacing: -1px;
        color: #707070;
    }

    .dropdown-menu {
        text-align: left;
        font: normal normal normal 14px/20px Noto Sans KR;
        letter-spacing: 0px;
        color: #707070;
        margin-left: 6%;
        padding-block: 2%;
    }

    .dropText {
        margin-left: 5%;
        margin-top: 3%;
        /* border-bottom: 1px solid #DBDBDB; */
        width: 95%;
        height: 40px;
        text-align: left;
        font: normal normal normal 20px/29px Noto Sans KR;
        letter-spacing: -1px;
        color: #707070;
    }

    #dropDownMenu >>> a{
        text-decoration:none; 
        color:#707070;
    }

    .depthMenu {
        height: 35px;
        margin-left: 5%;
    }

    .line {
        padding: 0;
        margin: 0;
        margin-bottom: 2%;
        display: block;
        height: 2px;
        /* border-top: 1px solid #DBDBDB; */
        border: 0;
        background-color: #DBDBDB;
    }

    .miniMenuLink {
       text-decoration:none; 
       color:#707070;
    }

    .miniMenuLink.router-link-exact-active {
        font: normal normal 14px/20px Noto Sans KR-BOLD;
        letter-spacing: 0px;
        color: #4C4C4C;
    }

    /* 반응형 웹 CSS */
    @media all and (max-width: 1474px) {
        .basic {
            float: left;
            width: 90vw;
        }

        .mainMenu {
            width: 22.6% !important;
        }
    }

    @media all and (max-width: 1440px) {

        .mainMenu {
            width: 23.3% !important;
        }

    }

    @media all and (max-width: 1200px) {

        .basic {
            width: 100vw;
        }

        .mainMenu {
            width: 25% !important;
        }

    }
    
    @media all and (max-width: 960px) {

        .mainMenu {
            display: none;
        }

    }
</style>